"use strict";
exports.__esModule = true;
exports.cachePluginMethods = exports.getCachedPluginMethods = void 0;
var cache = new WeakMap();
function getCachedPluginMethods(pluginName, context) {
    var methods = cache.get(context);
    return methods ? methods[pluginName] : null;
}
exports.getCachedPluginMethods = getCachedPluginMethods;
function cachePluginMethods(pluginName, context, pluginMethods) {
    var methods = cache.get(context);
    if (!methods) {
        methods = {};
        cache.set(context, methods);
    }
    methods[pluginName] = pluginMethods;
}
exports.cachePluginMethods = cachePluginMethods;
